import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewSidebarComponent } from './customer-review-sidebar.component';

runClientComponent({ CustomerReviewPdpSidebarComponent: CustomerReviewSidebarComponent });
